var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingAll"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"loading"},_vm._l((_vm.text),function(char,index){return _c('span',{style:({
              width: "20px",
              animationDuration: _vm.duration.indexOf("s") === -1 ? _vm.duration + "s" : _vm.duration ,
              animationDelay: parseInt(_vm.duration)/_vm.text.length*index +"s"
            })},[_vm._v("\n            "+_vm._s(char)+"\n          ")])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f36425e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/Loading.vue
// module id = null
// module chunks = 